// Social handles for Jacinto's Culinary Atelier.
// Update each URL as the Chef creates the accounts.
// Leave a value as empty string ("") to hide the icon.

export const SOCIAL = {
  instagram: "https://www.instagram.com/jacintosculinaryatelier",
  facebook: "https://www.facebook.com/jacintosculinaryatelier",
  pinterest: "https://www.pinterest.com/jacintosculinaryatelier",
  tiktok: "https://www.tiktok.com/@jacintosculinaryatelier",
  linkedin: "",
  youtube: "",
  blogspot: "https://jacintosculinaryatelier.blogspot.com",
};
